import Button from '@base/Button/Button';
import Dropdown from '@comp/Dropdown/Dropdown';
import styled from '@emotion/styled';
import { OutlinedInput } from '@material-ui/core';
import { Spacings, Fonts } from '@styles/index';

export const Container = styled.div`
  margin: auto;
  max-width: 1130px;
`;

export const Section = styled.div`
  position: relative;
  padding: ${Spacings.SPACING_6B} 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid var(--color-divider);
`;

export const Text = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
  color: var(--color-text-primary);
`;

export const StyledBtn = styled(Button)`
  height: 36px;
  min-height: 36px;
  padding: 0 ${Spacings.SPACING_3B};
  font-size: ${Fonts.H6};
  line-height: 18px;
  font-weight: bold;
  border-radius: 4px;
`;

export const StyledInput = styled(OutlinedInput)`
  height: 36px;

  &.MuiOutlinedInput-root .MuiInputBase-input {
    height: 36px;
    box-sizing: border-box;
    font-size: ${Fonts.H6};
    color: var(--color-text-primary);
  }
  &.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border-color: var(--color-divider);
    border-width: 1px;
  }
  &.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: var(--color-divider);
    border-width: 1px;
  }
`;

export const StyledDropdown = styled(Dropdown)`
  height: 36px;
  border-radius: 4px;
  border-color: var(--color-divider);
  background: transparent;
  font-weight: 400;

  &:hover {
    border-color: var(--color-divider);
  }

  svg {
    margin-left: ${Spacings.SPACING_2B};
  }
`;

export const Table = styled.table`
  border-radius: 4px;
  border-collapse: collapse;
  border: 1px solid var(--color-divider);
  width: 100%;
`;

export const TableHead = styled.tr`
  border-bottom: 1px solid var(--color-divider);
  background: var(--color-base-light-0);
`;

export const TableHeadCell = styled.th`
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_6B};
  font-size: ${Fonts.H7};
  font-weight: 600;
  line-height: 16px;
  text-transform: uppercase;
  color: var(--color-text-secondary);
  text-align: left;
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid var(--color-divider);
  cursor: pointer;

  &:hover {
    background: var(--color-base-light-0);
  }

  &:last-of-type {
    border-bottom: 0;
  }
`;

export const TableCell = styled.td`
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_6B};
  font-size: ${Fonts.H6};
  font-weight: 600;
  line-height: 18px;
  color: var(--color-text-primary);
`;
